import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="container mt-48 text-gray-700">
        <h1 className="mb-10 text-center text-2xl text-[#011473]">
          Privacy Policy
        </h1>
        <p>
          At <a className="font-bold text-black">Visa World,</a> accessible from{" "}
          <a href="https://visaworlds.net/" className="text-blue-500">
            visaworlds.net
          </a>
          , protecting your privacy is our top priority. This Privacy Policy
          outlines the types of information we collect, how it is used, and the
          measures we take to ensure its security. By accessing or using our
          services, you consent to the practices described in this policy.
        </p>

        <h2 className="mt-6 text-2xl text-[#011473]">
          1. Information We Collect
        </h2>
        <p>We collect the following types of information:</p>
        <ul className="list-inside list-disc text-black">
          <li className="  text-gray-700">
            <a className=" font-bold text-black">Personal Information:</a> Name,
            email address, contact number, and other details provided during
            inquiries or service requests.
          </li>
          <li className="  text-gray-700">
            <a className=" font-bold text-black">Transaction Data:</a> Details
            about payments and transactions processed through our platform.
          </li>
          <li className="  text-gray-700">
            <a className=" font-bold text-black">Technical Data:</a> Information
            collected through cookies and analytics tools, including IP
            addresses, browser types, and usage patterns.
          </li>
        </ul>

        <h2 className="mt-6 text-2xl text-[#011473]">
          2. How We Use Your Information
        </h2>
        <p>The collected information is used for:</p>
        <ul className="list-inside list-disc">
          <li>Providing, operating, and improving our services.</li>
          <li>Responding to inquiries and processing your service requests.</li>
          <li>Ensuring compliance with legal and regulatory requirements.</li>
          <li>Enhancing user experience through personalized services.</li>
        </ul>

        <h2 className="mt-6 text-2xl text-[#011473]">
          3. Sharing Your Information
        </h2>
        <p>
          We do not sell or rent your information to third parties. However, we
          may share information with:
        </p>
        <ul className="list-inside list-disc text-black">
          <li className="  text-gray-700">
            <a className=" font-bold text-black">Service Providers:</a> To
            facilitate operations like payment processing.
          </li>
          <li className="  text-gray-700">
            <a className=" font-bold text-black">Legal Authorities:</a> If
            required by law or to protect our rights and comply with legal
            proceedings.
          </li>
        </ul>

        <h2 className="mt-6 text-2xl text-[#011473]">4. Security Measures</h2>
        <p>
          We use industry-standard security measures to protect your data from
          unauthorized access, alteration, or disclosure. Despite these
          measures, no method of transmission or storage is 100% secure.
        </p>

        <h2 className="mt-6 text-2xl text-[#011473]">5. Your Rights</h2>
        <p>
          You have the right to access, update, or delete your personal
          information. For any requests or concerns, contact us at
          <br></br>
          <a href="mailto:info@visaworlds.net" className="text-[#006CFF]">
            info@visaworlds.net
          </a>
          .
        </p>

        <h2 className="mt-6 text-2xl text-[#011473]">Disclaimer</h2>
        <p>
          The information provided on the Visa World website (visaworlds.net) is
          for general informational purposes only. While we strive to keep
          information accurate and up-to-date, we make no guarantees of any
          kind, express or implied, about the accuracy, reliability, or
          suitability of the information provided.
        </p>
        <ul className="list-inside list-disc">
          <li>
            Use of information or services on this site is at your own risk.
          </li>
          <li>
            Visa processes and outcomes depend on government policies, for which
            Visa World holds no responsibility for delays or denials.
          </li>
          <li>
            External links provided are for convenience only, and we are not
            responsible for the content or practices of linked websites.
          </li>
        </ul>
        <div className="container mt-6 text-gray-700">
          <h2 className="text-2xl font-semibold text-[#011473]">Key Points</h2>
          <ul className="mt-4 list-inside list-disc space-y-2">
            <li>
              Use of information or services on this site is at your own risk.
            </li>
            <li>
              Visa processes and outcomes depend on government policies, for
              which Visa World holds no responsibility for delays or denials.
            </li>
            <li>
              External links provided are for convenience only, and we are not
              responsible for the content or practices of linked websites.
            </li>
          </ul>
        </div>
      </div>
      <div className="container mt-24 text-gray-700">
        <h1 className="mb-10 text-center text-2xl text-[#011473]">
          Terms and Conditions
        </h1>
        <p>
          Welcome to <a className="font-bold text-black">Visa World!</a> These
          Terms and Conditions govern your access and use of our website
          (visaworlds.net) and the services provided by Visa World. By using our
          services, you agree to these terms in full. If you do not agree with
          any part of these terms, you should refrain from using our website or
          services.
        </p>

        <h2 className="mt-6 text-2xl text-[#011473]">1. Definitions</h2>
        <ul className="list-inside list-disc">
          <li>
            <b className=" font-bold text-black">
              “Visa World,” “we,” “us,” or “our”:
            </b>{" "}
            Refers to Visa World, its affiliates, subsidiaries, and employees.
          </li>
          <li>
            <b className=" font-bold text-black">“User” or “you”:</b> Refers to
            any individual or entity accessing or using our website and
            services.
          </li>
          <li>
            <b className=" font-bold text-black">“Services”:</b> Includes visa
            consultancy, visa application processing, and related support
            provided by Visa World.
          </li>
        </ul>

        <h2 className="mt-6 text-2xl text-[#011473]">
          2. Use of Website and Services
        </h2>
        <ul className="list-inside list-disc">
          <li>
            <b className=" font-bold text-black">Eligibility:</b> By using our
            services, you confirm that you are at least 18 years old and have
            the legal capacity to enter into binding agreements.
          </li>
          <li>
            <b className=" font-bold text-black">Accuracy of Information:</b>{" "}
            You agree to provide accurate, complete, and up-to-date information
            when using our services.
          </li>
          <li>
            <b className=" font-bold text-black">Prohibited Use:</b> You must
            not use the website or services for unlawful purposes or
            misrepresentation.
          </li>
        </ul>

        <h2 className="mt-6 text-2xl text-[#011473]">3. Scope of Services</h2>
        <ul className="list-inside list-disc">
          <li>
            Visa World facilitates visa application processes, provides
            consultation, and supports applicants with documentation and
            submission.
          </li>
          <li>
            We act as intermediaries and are not responsible for decisions,
            delays, or actions taken by government authorities.
          </li>
          <li>
            Our services do not include guaranteeing visa approvals or specific
            timelines.
          </li>
        </ul>

        <h2 className="mt-6 text-2xl text-[#011473]">4. Fees and Payment</h2>
        <ul className="list-inside list-disc">
          <li>
            <b className=" font-bold text-black">Payment Obligations:</b> All
            fees for services must be paid in full before processing begins.
          </li>
          <li>
            <b className=" font-bold text-black">Non-Refundable Fees:</b>{" "}
            Payments made to Visa World are non-refundable unless stated
            otherwise in a written agreement.
          </li>
          <li>
            <b className=" font-bold text-black">Additional Costs:</b> Visa
            application fees charged by government authorities, courier fees, or
            other associated costs are separate.
          </li>
        </ul>

        <div className="container mt-6 text-gray-700">
          <h2 className="text-2xl font-bold text-[#011473]">
            5. Intellectual Property
          </h2>
          <li className="mt-2">
            All content, designs, logos, and materials on
            <a href="https://visaworlds.net" className="italic text-blue-600">
              {" "}
              visaworlds.net{" "}
            </a>{" "}
            are the exclusive property of Visa World and are protected under
            applicable copyright and trademark laws.
          </li>
          <li className="mt-2">
            You are granted a limited license to access and use the website
            solely for personal, non-commercial purposes.
          </li>
          <li className="mt-2">
            Unauthorized copying, distribution, or modification of any content
            on the website is strictly prohibited.
          </li>

          <h2 className="mt-6 text-2xl font-semibold text-[#011473]">
            6. Disclaimer of Liability
          </h2>
          <li className="mt-2">
            Visa World will not be held liable for any losses or damages
            resulting from the use of our services or website, including but not
            limited to:
          </li>
          <ul className="mt-2 list-inside list-disc space-y-2">
            <li>Denial of visa applications.</li>
            <li>Delays in processing.</li>
            <li>Miscommunication or errors in submitted information.</li>
          </ul>
          <li className="mt-2">
            The website is provided <span className="italic">"as-is"</span>, and
            we do not warrant that it will operate error-free or without
            interruptions.
          </li>

          <h2 className="mt-6 text-2xl font-semibold text-[#011473]">
            7. User Responsibilities
          </h2>
          <li className="mt-2"> You are solely responsible for:</li>
          <ul className="mt-2 list-inside list-disc space-y-2">
            <li>
              Submitting accurate and complete information for your visa
              application.
            </li>
            <li>
              Ensuring compliance with the laws of your destination country.
            </li>
          </ul>
          <li className="mt-2">
            You must regularly check the status of your application and follow
            the guidelines provided by Visa World or government authorities.
          </li>

          <h2 className="mt-6 text-2xl font-semibold text-[#011473]">
            8. Confidentiality and Privacy
          </h2>
          <li className="mt-2">
            Your personal information will be handled per our Privacy Policy,
            available on our website.
          </li>
          <li className="mt-2">
            Visa World implements reasonable safeguards to protect user data but
            cannot guarantee absolute security against unauthorized access.
          </li>

          <h2 className="mt-6 text-2xl font-semibold text-[#011473]">
            9. Governing Law and Jurisdiction
          </h2>
          <li className="mt-2">
            These Terms and Conditions are governed by the laws of the United
            Arab Emirates (UAE).
          </li>
          <li className="mt-2">
            Any disputes arising out of or in connection with these terms shall
            be subject to the exclusive jurisdiction of the courts in the UAE.
          </li>

          <h2 className="mt-6 text-2xl font-semibold text-[#011473]">
            10. Changes to Terms and Conditions
          </h2>
          <li className="mt-2">
            Visa World reserves the right to modify these Terms and Conditions
            at any time. Updates will be posted on our website, and continued
            use of the website or services indicates acceptance of the revised
            terms.
          </li>
        </div>

        <h2 className="mt-6 text-[#011473]">Contact Information</h2>
        <h3 className="mb-2 text-[#011473]">UAE Headquarters:</h3>
        <p>
          Branch #1414, Tamani Arts Office
          <br /> Business Bay, Dubai, United Arab Emirates
          <br /> +971 50 287 0799
          <br />
          <a href="mailto:info@visaworlds.net" className="text-[#006CFF]">
            info@visaworlds.net
          </a>
        </p>
        <h3 className="mb-2 mt-5 text-[#011473]">New York Office:</h3>
        <p>
          RBK Consultancy Services LLC
          <br /> 244 5th Ave, Suite #R235
          <br /> New York, NY 10001, United States
          <br /> +1 (929) 309-1457
          <br />
          <a href="mailto:info@visaworlds.net" className="text-[#006CFF]">
            info@visaworlds.net
          </a>
        </p>
        <p className="mt-10">
          If you have any questions or concerns about these Terms and
          Conditions, please contact us at:
        </p>
        <ul className="mt-2 space-y-2">
          <li>
            <span className="font-semibold text-black">Email:</span>
            <a href="mailto:info@visaworlds.net" className="text-[#006CFF]">
              {" "}
              info@visaworlds.net
            </a>
          </li>
          <li>
            <span className="font-semibold text-black">Phone:</span> +971 50 287
            0799
          </li>
          <li>
            <span className="font-semibold text-black">Address:</span> Branch
            #1414, Tamani Arts Office, Business Bay, Dubai, United Arab Emirates
          </li>
        </ul>
        <p className="mt-4 text-sm italic text-gray-700">
          These terms and conditions were last updated on [ 24-Nov-2024 ].
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
